// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_Tight_845569', '__Inter_Tight_Fallback_845569'","fontStyle":"normal"},"className":"__className_845569","variable":"__variable_845569"};